module.exports = __webpack_public_path__ + "img/down_arrow.4f969f83.svg";